export enum LocalStorageKeys {
    ActiveCompanyCode = 'active-company-code',
    ActiveCompanyID = 'active-company-id',
    LoginToken = 'login-token',
    UserFullName = 'user-full-name',
    Permissions = 'Permissions',
    ActiveBranchID = 'activeBranchID',
    ActiveBranchName = 'activeBranchName',
    ActiveBranchCode = 'activeBranchCode',
    CompanyName = 'companyName',
    AccessableBrancheCount = 'accessableBrancheCount',
    Logo = 'logo',
    ActiveSaleMethod = 'active-sale-method',
    LanguageCode = 'langauge-code',
    DeviceToken = 'autoexpert-device-token',
    UserLoginId = 'user-login-id',
    Ledgers = 'Ledgers',
    ISO_RetailOrder_Prefix = 'ISO_RetailOrder_Prefix',
    ISO_WholesaleOrder_Prefix = 'ISO_WholesaleOrder_Prefix',
}